module.exports = __webpack_public_path__ + "51496ddf1ce33c063212ff1323c0e7b7.woff2";